<a
  [routerLink]="['/promotions', promotion?.id]"
  class="promotion-item"
  *ngIf="promotionContent && promotionContent.promotionImage"
>
  <img [src]="promotionContent.promotionImage.thumbnailBlobStorageUrl" />
</a>
